/**
 * Warms expo-image disk + memory cache for flag asset URLs so FlashList scroll
 * does not re-hit the network for the same flags when cells remount.
 */

import { Image } from 'expo-image';
import { getFlagCdnUrl } from './flagCdn.helper';

/**
 * Fire-and-forget prefetch of unique flag URLs for the given ISO codes.
 */
export function prefetchFlagCdnForCountryCodes(codes: readonly string[]): void {
  const urls: string[] = [];
  const seen = new Set<string>();
  for (const code of codes) {
    const url = getFlagCdnUrl(code);
    if (!url || seen.has(url)) continue;
    seen.add(url);
    urls.push(url);
  }
  if (urls.length === 0) return;

  void Image.prefetch(urls, { cachePolicy: 'memory-disk' }).catch(() => {
    // Best-effort; UI still loads flags on demand.
  });
}
